import styled from 'styled-components';
import cx from 'classnames';
import IconCheck from './IconCheck';
import { forwardRef } from 'react';

const UncontrolledCheckbox = forwardRef(
  ({ className, wrapperProps = {}, girded = false, label, ...props }, ref) => {
    return (
      <label className={className} {...wrapperProps}>
        <input ref={ref} type="checkbox" className="UncontrolledCheckbox__checkbox" {...props} />
        <div
          className={cx('UncontrolledCheckbox__label', {
            UncontrolledCheckbox__girded: girded,
          })}
        >
          {label}
          <IconCheck className="UncontrolledCheckbox__icon_check" />
        </div>
      </label>
    );
  }
);

export default styled(UncontrolledCheckbox)`
  & {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: var(--grey900);
    user-select: none;
  }

  &:hover {
    .UncontrolledCheckbox__girded {
      border-color: var(--primary300);
      background-color: var(--primary50);
    }

    .UncontrolledCheckbox__label:before {
      border-color: var(--primary500);
      background-color: var(--white);
    }
  }

  .UncontrolledCheckbox__checkbox:focus + .UncontrolledCheckbox__label {
    &.UncontrolledCheckbox__girded {
      border-color: var(--primary300);
      background-color: var(--primary50);
    }

    &:before {
      border-color: var(--primary500);
      background-color: var(--white);
    }
  }

  .UncontrolledCheckbox__checkbox {
    opacity: 0;
    position: absolute;
    left: -99999px;
  }

  .UncontrolledCheckbox__label {
    display: inline-flex;
    align-items: center;
    pointer-events: none;
    position: relative;
  }

  .UncontrolledCheckbox__girded {
    background: #fff;
    padding: 6px;
    border: 1px solid var(--grey500);
    border-radius: 4px;
  }

  .UncontrolledCheckbox__label:before {
    content: '';
    width: 20px;
    height: 20px;
    border: 1px solid var(--grey500);
    display: inline-block;
    border-radius: 4px;
    margin-right: 8px;
    background-color: var(--white);
  }

  .UncontrolledCheckbox__icon_check {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    left: 3px;
    opacity: 0;
  }

  .UncontrolledCheckbox__girded {
    .UncontrolledCheckbox__icon_check {
      left: 9px;
    }
  }

  .UncontrolledCheckbox__checkbox:checked + .UncontrolledCheckbox__label {
    &.UncontrolledCheckbox__girded {
      background-color: var(--primary100);
    }

    .UncontrolledCheckbox__icon_check {
      color: #fff;
      opacity: 1;
    }

    &:before {
      background-color: var(--primary500);
      border-color: var(--primary500);
    }
  }
`;
